<template>
  <div
    v-if="!confirmed && !chat.closed"
    class="conversation-buttons-container"
    :class="{ 'multi-select--offset': showSelect }"
    :style="dynamicColors"
  >
    <ConversationSelect
      v-if="showSelect"
      :options="buttons"
      :placeholder="$t('bot.buttons.select.placeholder')"
      @selected="handleSelect"
    />

    <template v-else>
      <span class="buttons-placeholder-container">
        {{ $t('bot.buttons.placeholder') }}
      </span>

      <ul
        class="list-button-options"
        :class="{
          'column-items': buttonLabelMaxSize > optionAvgSize,
          'dual-items': buttonLabelMaxSize <= optionAvgSize
        }"
      >
        <li v-for="button in buttons" :key="button.id">
          <ConversationButtonItem
            :button="button"
            :multi-select="multiSelect"
            @multiSelected="handleMultiSelect"
          />
        </li>
      </ul>
    </template>

    <button
      v-if="selections.length > 0"
      class="
        btn
        bot-buttons-confirm
        space-bottom-xs space-right-xs space-top-md
      "
      :style="dynamicColors"
      @click="confirmMultiSelection"
    >
      {{ $t('bot.buttons.confirm') }}
    </button>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import ConversationButtonItem from './ConversationButtonItem'

  import ConversationSelect from './ConversationSelect.vue'

  export default {
    components: {
      ConversationSelect,
      ConversationButtonItem
    },
    props: ['value', 'message'],
    data() {
      return {
        selections: [],
        confirmed: false,
        optionAvgSize: 16
      }
    },
    computed: {
      ...mapGetters(['settings', 'chat']),
      extendedData() {
        return this.message && this.message.extendedData
      },
      buttons() {
        return (
          this.extendedData &&
          this.extendedData.bot &&
          this.extendedData.bot.buttons
        )
      },
      multiSelect() {
        return (
          this.extendedData &&
          this.extendedData.bot &&
          this.extendedData.bot.multiSelect
        )
      },
      buttonLabelMaxSize() {
        let max = 0

        this.buttons &&
          this.buttons.forEach(button => {
            if (button && button.label && button.label.length > max) {
              max = button.label.length
            }
          })

        return max
      },
      dynamicColors() {
        return {
          '--button-outline-bg': `rgba(${this.settings.bgColorRGBA})`,
          '--button-active-bg': `rgba(${this.settings.bgColorRGBA})`,
          '--button-active-color': `rgba(${this.settings.fontColorRGBA})`
        }
      },
      showSelect() {
        return this.buttons && this.buttons.length >= 6
      }
    },
    methods: {
      ...mapActions(['sendMessage']),
      getSelectionsTexts() {
        return this.selections.map(b => b.label).join(', ')
      },
      confirmMultiSelection() {
        if (this.selections.length > 0) {
          this.sendMessage({
            comment: this.getSelectionsTexts(),
            extendedData: { client: { buttons: this.selections } }
          }).then(() => {
            this.message.replied = true

            this.confirmed = true
          })
        }
      },
      handleMultiSelect({ button, type }) {
        if (type === 'selected') {
          this.selections.push(button)
        } else if (type === 'deselected') {
          this.selections = this.selections.filter(b => b.id !== button.id)
        }
      },
      handleSelect(button) {
        this.selections = [button]
      }
    }
  }
</script>

<style lang="scss">
  .conversation-buttons-container {
    margin-top: 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    .buttons-placeholder-container {
      display: block;
      text-align: right;
      font-size: 14px;
    }
  }
  ul.list-button-options {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    padding: 15px 0;
    padding-top: 0.2rem;
    margin: 0px;
    list-style: none;
    .btn-selected {
      color: var(--button-active-color) !important;
      border-color: var(--button-active-bg) !important;
      background-color: var(--button-active-bg) !important;
    }
    li button {
      border-radius: 5px;
      margin: 0px 0px 8px 8px;
      font-size: 14px;
      word-break: keep-all;
      padding: 10px 7px;
      border-width: 1px;
      border-style: solid;
      transition: 0.5s;
      cursor: pointer;
      border: 1px solid #7d8f9c;
      color: #7d8f9c;
      i {
        font-style: italic;
      }
      p {
        margin-top: 0px;
        &:last-child {
          margin-bottom: 0px;
        }
      }
      &:hover {
        color: var(--button-active-bg);
        border: 1px solid var(--button-active-bg);
      }
      &:active {
        background-color: var(--button-active-bg) !important;
        color: var(--button-active-color) !important;
        border: 1px solid var(--button-active-bg) !important;
      }
    }
    &.not-message {
      padding: 25px 25px 17px 25px;
    }
    &.dual-items {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 10px;
      margin-top: 5px;
      li {
        margin-bottom: 10px;
        button {
          width: 100%;
          min-height: 50px;
          height: 100%;
          margin: 0px;
        }
      }
    }
    &.column-items {
      flex-direction: column;
      li {
        width: 100%;
        button {
          width: 100%;
        }
      }
    }
  }
  .bot-buttons-confirm {
    float: right;
    background-color: var(--button-active-bg);
    color: var(--button-active-color);
    border: 1px solid var(--buttons-active-bg);
    border-radius: 5px;
  }
</style>
